import styled from 'styled-components'
import { CloseIcon } from 'vvs-uikit'

interface CloseButtonProps {
  onClick?: () => void
  fill?: string
}

export const CloseButton = ({ onClick, fill }: CloseButtonProps) => (
  <Button onClick={onClick}>
    <CloseIcon fill={fill} />
  </Button>
)

export const Button = styled.button`
  background-color: transparent;
  cursor: pointer;
  border: none;
`
